export interface IDonorShieldInviteOutcome {
    inviteAttempted?: boolean;
    inviteSent?: boolean;
    inviteSkippedReason?: string;
    profileEnsured?: boolean;
    preOpScheduledNoticeSent?: boolean;
}

export const DONOR_SHIELD_INVITE_SKIP_ALREADY_INVITED = 'AlreadyInvited';

export function didDonorShieldInviteFail(outcome: IDonorShieldInviteOutcome | null | undefined): boolean {
    if (!outcome) {
        return false;
    }
    if (outcome.inviteSent) {
        return false;
    }
    if (outcome.inviteSkippedReason === DONOR_SHIELD_INVITE_SKIP_ALREADY_INVITED) {
        return false;
    }
    return !!outcome.inviteAttempted || !!outcome.inviteSkippedReason;
}

export function shouldWarnDonorShieldInviteNotSent(
    outcome: IDonorShieldInviteOutcome | null | undefined,
    preOpNoticeSent?: boolean
): boolean {
    if (preOpNoticeSent) {
        return false;
    }
    return didDonorShieldInviteFail(outcome);
}

export function donorShieldInviteNotSentMessage(outcome: IDonorShieldInviteOutcome | null | undefined): string {
    const reason = (outcome?.inviteSkippedReason || '').trim();
    if (reason && reason !== DONOR_SHIELD_INVITE_SKIP_ALREADY_INVITED) {
        return `Network status was saved, but Donor Shield invite was not sent (${reason}).`;
    }
    return 'Network status was saved, but Donor Shield invite was not sent.';
}
